import { Injectable } from '@angular/core';
import { ProjectModelEndpointWithRelations } from '@rappider/rappider-sdk';
import { ApiEndpointMethodColorMapping } from '../../configs/project';

@Injectable({
  providedIn: 'root'
})
export class EndpointListService {

  constructor() { }

  convertTreeToList(root: any): any[] {
    const stack: any[] = [];
    const array: any[] = [];
    const hashMap = {};
    stack.push({ ...root, level: 0, expand: true });

    while (stack.length !== 0) {
      const node = stack.pop();
      this.visitNode(node, hashMap, array);
      if (node.children) {
        stack.push(
          ...node.children.reverse().map(item => ({
            ...item,
            level: node.level + 1,
            expand: false,
            parent: node
          }))
        );
      }
    }

    return array;
  }

  visitNode(node: any, hashMap: { [key: string]: boolean }, array: any[]): void {
    if (!hashMap[node.key]) {
      hashMap[node.key] = true;
      array.push(node);
    }
  }

  setProjectModelEndpointTagColorByMethodName(projectModelEndpoint: ProjectModelEndpointWithRelations) {
    return {
      ...projectModelEndpoint,
      method: projectModelEndpoint.method.toUpperCase(),
      metadata: {
        color: ApiEndpointMethodColorMapping[projectModelEndpoint.method.toLowerCase()]
      }
    };
  }
}
